// AuthPanel.tsx - Authentication panel component
import { Panel } from "./Panel";

export const AuthPanel = () => {
  return (
    <Panel title="PILOT">
      {/* Guest status display */}
      <div className="auth-form active" id="guestAuthForm">
        <div className="player-badge">
          <div className="player-callsign" id="guestCallsign">
            --
          </div>
          <div className="player-role">GUEST</div>
        </div>

        <div className="auth-divider">SIGN IN TO SAVE PROGRESS</div>

        <button
          type="button"
          className="auth-button discord-button"
          id="discordLoginBtn"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="currentColor"
            role="img"
            aria-label="Discord logo"
          >
            <title>Discord</title>
            <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.730 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.730 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
          </svg>
          Sign in with Discord
        </button>
      </div>

      {/* Logged in state */}
      <div id="loggedIn" className="account-info" style={{ display: "none" }}>
        <div className="player-card-header">
          <div className="player-card-user">
            <div className="player-avatar-container">
              <img
                id="accountAvatar"
                className="player-avatar"
                src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48'%3E%3Crect width='48' height='48' fill='%23374151'/%3E%3C/svg%3E"
                alt="Player avatar"
              />
              <div className="discord-badge">
                <svg width="10" height="10" viewBox="0 0 16 16" fill="white">
                  <title>Discord connected</title>
                  <path d="M13.545 2.907a13.227 13.227 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.19 12.19 0 0 0-3.658 0 8.258 8.258 0 0 0-.412-.833.051.051 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.041.041 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032c.001.014.01.028.021.037a13.276 13.276 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019c.308-.42.582-.863.818-1.329a.05.05 0 0 0-.01-.059.051.051 0 0 0-.018-.011 8.875 8.875 0 0 1-1.248-.595.05.05 0 0 1-.02-.066.051.051 0 0 1 .015-.019c.084-.063.168-.129.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.052.052 0 0 1 .053.007c.08.066.164.132.248.195a.051.051 0 0 1-.004.085 8.254 8.254 0 0 1-1.249.594.05.05 0 0 0-.03.03.052.052 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.235 13.235 0 0 0 4.001-2.02.049.049 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.034.034 0 0 0-.02-.019Zm-8.198 7.307c-.789 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.45.730 1.438 1.613 0 .888-.637 1.612-1.438 1.612Zm5.316 0c-.788 0-1.438-.724-1.438-1.612 0-.889.637-1.613 1.438-1.613.807 0 1.451.730 1.438 1.613 0 .888-.631 1.612-1.438 1.612Z" />
                </svg>
              </div>
            </div>
            <div className="player-card-name" id="accountUsername">
              --
            </div>
          </div>
        </div>
        <div className="player-card-divider"></div>
        <div className="account-stats-horizontal">
          <div className="account-stat wins">
            <span className="account-stat-icon">★</span>
            <div className="account-stat-info">
              <span className="account-stat-value" id="accountWins">
                0
              </span>
              <span className="account-stat-label">Wins</span>
            </div>
          </div>
          <div className="account-stat kills">
            <span className="account-stat-icon">⚔</span>
            <div className="account-stat-info">
              <span className="account-stat-value" id="accountKills">
                0
              </span>
              <span className="account-stat-label">Kills</span>
            </div>
          </div>
          <div className="account-stat deaths">
            <span className="account-stat-icon">✕</span>
            <div className="account-stat-info">
              <span className="account-stat-value" id="accountDeaths">
                0
              </span>
              <span className="account-stat-label">Deaths</span>
            </div>
          </div>
          <div className="account-stat pellets">
            <span className="account-stat-icon">◆</span>
            <div className="account-stat-info">
              <span className="account-stat-value" id="accountPellets">
                0
              </span>
              <span className="account-stat-label">Pellets</span>
            </div>
          </div>
          <div className="account-stat games">
            <span className="account-stat-icon">◉</span>
            <div className="account-stat-info">
              <span className="account-stat-value" id="accountGames">
                0
              </span>
              <span className="account-stat-label">Games</span>
            </div>
          </div>
        </div>
      </div>
    </Panel>
  );
};
